module.exports = __webpack_public_path__ + "img/convert-abandon.bbbb1867.png";